import * as React from 'react';
import { Button, Image, Theme, UIHeading3 } from '@cian/ui-kit';

import { IPromoBanner } from '../../../types/newbuildingBanners/promoBanner';
import { TBannerTheme } from '../utils/bannerTypeToTheme';
import { Banner } from '../Banner/Banner';

import * as styles from './NewbuildingBrokerBanner.css';

interface INewbuildingBrokerBannerProps extends IPromoBanner {
  theme: TBannerTheme;
  loading: boolean;
  onClick(): void;
}

const DEFAULT_ACTION_TEXT = 'К заявке';

// TODO: В случае победы эксперимента в CD-243912 переименовать директорию в NewbuildingBrokerBanner.
export const NewbuildingBrokerBanner = ({
  action,
  imageUrl,
  title,
  theme,
  loading,
  onClick,
}: INewbuildingBrokerBannerProps) => {
  return (
    <Banner
      onClick={onClick}
      theme={theme}
      title=""
      imageUrl={null}
      labels={null}
      subtitle=""
      customClassName={styles['custom-container']}
      customContent={
        <div className={styles['custom-content']}>
          <Image src={imageUrl ?? ''} objectFit="contain" height="auto" />
          <div className={styles['title']}>
            <UIHeading3 color="text-inverted-default">{title}</UIHeading3>
          </div>
        </div>
      }
      footer={
        <div className={styles['footer-button']} onMouseDown={event => event.stopPropagation()}>
          <Theme theme="colored">
            <Button loading={loading} onClick={onClick} fullWidth>
              {action.title || DEFAULT_ACTION_TEXT}
            </Button>
          </Theme>
        </div>
      }
    />
  );
};
